import React, { useContext } from "react";
import { getCDNImage } from "../globals";
import { Card, Col, Row, Button } from "react-bootstrap";
import { T } from "react-translator-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { Building } from "../components/Icons";
import { invertDate, formatDate, i18nValue, formatDayMonth, reservationDisplayCode } from "../functions";
import { CheckInContext } from "../context/checkin";
import { UserContext } from "../context/user";
import { format } from "date-fns";
import { HotelContext } from "../context/hotel";
import { NavLink, useLocation } from 'react-router-dom';
import { isCostaGalana, isOffgrid, isHostz, isBelAir, isAlvarezArguellez } from "./CheckIn/hotelConditions";
import { faArrowRight, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { useMemo } from "react";

export default function Reservation(props) {
  const { language, agent } = useContext(UserContext);
  const { pathname } = useLocation();
  const { data, getUrlPath } = useContext(HotelContext);
  const { data: checkIn, webCheckInDone } = useContext(CheckInContext);
  let {
    className,
    showMainGuest = true,
    showStatus = false,
    showRowInfo = true,
    showPrice = true,
    variant = "normal",
    border = true,
    onlyInfo = false,
    error = checkIn.status === "observed" || checkIn.showNotification === 50,
    ...otherProps
  } = props;
  const classNames = [!border ? "rounded-0 border-0" : "", className].join(" ");
  const guestFullname = [checkIn.reservation?.primaryGuest?.title, (checkIn.passengers?.[0]?.name || checkIn.reservation?.primaryGuest?.firstName), (checkIn.passengers?.[0]?.surname || checkIn.reservation?.primaryGuest?.lastName)].join(" ");
  const guestSimplename = checkIn.passengers?.[0]?.name || checkIn.reservation?.primaryGuest?.firstName;

  let _styles = {};
  if (error && !onlyInfo) {
    _styles = { ..._styles, borderColor: "red" }
  }

  const showBottomMessage = useMemo(() => {
    if (onlyInfo) { return false; }

    return !(checkIn.status === "done" || checkIn.status === "canceled" || checkIn.status === "no_show")
  }, [checkIn])



  let showEditRow = false;
  let showPendingCheckInRow = false;
  let cardLinkTo = null;

  if (pathname === `/${data.code}/home`) {
    cardLinkTo = `/${data.code}/checkin/status`;
  }
  /* Si la reserva está aceptada, no se muestra el botón de edición */
  if (pathname === `/${data.code}/checkin/status` && checkIn.status !== "accepted") {
    if (checkIn.status !== "in_stay" && checkIn.status !== "canceled") {
      cardLinkTo = `/${data.code}/checkin/edit`;
      showEditRow = true;
    } else {
      if (!webCheckInDone && checkIn.status === "in_stay" && !isAlvarezArguellez(data?.id) && !isCostaGalana(data?.id) && !isBelAir(data?.id) && !isOffgrid(data?.id) && !isHostz(data?.id)) {
        showPendingCheckInRow = true
        cardLinkTo = `/${data.code}/checkin/edit`;
      } else {
        cardLinkTo = `/${data.code}/stay`;
      }
    }
  }
  if (variant === "normal" && error) {
    cardLinkTo = `/${data.code}/checkin/messages`;
  }
  if (!showBottomMessage) {
    cardLinkTo = null;
  }


  return (

    <NavLink className="text-decoration-none reservation-card-info-container" style={{ color: 'inherit', cursor: variant === "normal" && error ? "pointer" : "default" }} to={cardLinkTo}>
      <Card
        border="default"
        className={classNames}
        style={{ ..._styles, ...(otherProps.style ?? {}) }}
      >
        <Card.Body className="py-2 px-3">

          {showStatus && checkIn.status !== "in_stay" && (
            <Row style={{ borderBottom: "1px solid #EEE" }}>
              <Col xs={12}>
                <div className="d-flex justify-content-between general-text-sm pb-2">
                  <span style={{ lineHeight: 1.8 }}>
                    {T("checkin.initiated")}
                  </span>
                  {checkIn.status && <span
                    className={`label label-sm label-light-${checkIn.status} label-inline text-uppercase d-inline-block`}
                  >
                    {T(`checkin.status-${checkIn.status}`)}
                  </span>}
                </div>
              </Col>
            </Row>
          )}
          {showRowInfo && <RoomInfo variant={variant} checkIn={checkIn} language={language} showPrice={showPrice} />}
          {checkIn.linked_checkins && checkIn.linked_checkins.map(r => <RoomInfo variant={variant} checkIn={r} language={language} showPrice={showPrice} />)}
          {variant === "normal" && (
            <Row style={{ borderTop: "1px solid #EEE", paddingBottom: 5 }}>
              <Col xs={12}>
                <div className="d-flex justify-content-between general-text-sm pt-1">
                  <span>{T("checkin.reservation-code")}</span>
                  <span className="text-right font-weight-bold">
                    {reservationDisplayCode(checkIn)}
                  </span>
                </div>
              </Col>
            </Row>
          )}
          {variant === "normal" && showMainGuest && (
            <Row style={{ borderTop: "1px solid #EEE", paddingBottom: 5 }}>
              <Col xs={12}>
                <div className="d-flex justify-content-between general-text-sm pt-1">
                  <span>{T("checkin.primary-guest")}</span>
                  <span className="text-right font-weight-bold">
                    {isOffgrid(data?.id) ? guestSimplename : guestFullname}
                  </span>
                </div>
              </Col>
            </Row>
          )}
          {checkIn.reservation && variant === "normal" && (
            <Row style={{ borderTop: "1px solid #EEE" }}>
              <Col xs={12}>
                <div className="d-flex justify-content-between general-text-sm pt-1">
                  <span>
                    <FontAwesomeIcon
                      icon={faCalendarAlt}
                      className="mr-1 text-muted"
                    />
                    {formatDayMonth(checkIn.reservation.arrival, T("general.short-dateformat"))}
                    {/* {format(
                      new Date(checkIn.reservation.arrival),
                      T("general.short-dateformat")
                    )} */}
                    {" "}
                    -{" "}
                    {formatDayMonth(checkIn.reservation.departure, T("general.short-dateformat"))}
                    {/* {format(
                      new Date(checkIn.reservation.departure),
                      T("general.short-dateformat")
                    )} */}
                    {" "}
                    {showPrice && <span className="font-italic text-muted">
                      ({checkIn.reservation.adults} {T("checkin.adult-s")}
                      {checkIn.reservation.childrenAges?.length > 0
                        ? " / " +
                        checkIn.reservation.childrenAges.length +
                        T("checkin.child-s")
                        : ""}
                      )
                    </span>}
                  </span>
                  {showPrice && <span className="text-right font-weight-bold">
                    {checkIn.reservation.totalGrossAmount.amount}{" "}
                    {checkIn.reservation.totalGrossAmount.currency}
                  </span>}
                  {!showPrice && !checkIn.linked_checkins && <span className="text-right font-weight-bold">
                    {checkIn.reservation.adults} {T("checkin.adult-s")}
                    {checkIn.reservation.childrenAges?.length > 0
                      ? " / " +
                      checkIn.reservation.childrenAges.length +
                      T("checkin.child-s")
                      : ""}
                  </span>}
                  {!showPrice && checkIn.linked_checkins?.[0] && <div>
                    <span className="text-right font-weight-bold">
                      <small className="text-muted text-uppercase mr-3">{T("checkin.short-room")} 1</small> {checkIn.reservation.adults} {T("checkin.adult-s")}
                      {checkIn.reservation.childrenAges?.length > 0
                        ? " / " +
                        checkIn.reservation.childrenAges.length +
                        T("checkin.child-s")
                        : ""}
                    </span>
                    <br />
                    <span className="text-right font-weight-bold">
                      <small className="text-muted text-uppercase mr-3">{T("checkin.short-room")} 2</small>
                      {checkIn.linked_checkins?.[0]?.guestCounts?.adults > 0
                        ? checkIn.linked_checkins[0].guestCounts.adults + " " + T("checkin.adult-s")
                        : ""
                      }
                      {checkIn.linked_checkins?.[0]?.guestCounts?.children > 0
                        ? " " + checkIn.linked_checkins[0].guestCounts.children +
                        " " + T("checkin.child-s")
                        : ""}
                    </span>
                  </div>}
                </div>
              </Col>
            </Row>
          )}

          {showBottomMessage && <>
            {variant === "normal" && !error && showPendingCheckInRow && <Row className="mt-1" style={{ borderTop: "1px solid #EEE" }}>
              <Col xs={12} className="text-center pt-3 pb-2" style={{ background: "#fdf9d4", marginBottom: -8 }}>
                <b className="text-danger text-uppercase">{T('checkin.please-complete-your-checkin-title')}!</b><br />
                <a style={{ color: '#666', fontSize: 13 }} href={getUrlPath("/checkin")}>{T('checkin.please-complete-your-checkin-text')}</a>
                {/* {error && <NavLink className="text-decoration-none" style={{ color: 'inherit' }} to={`/${data.code}/checkin?edit=true`}>Edit</NavLink>} */}
              </Col>
            </Row>}
            {variant === "normal" && error &&
              <Row className="mt-1">
                <Col className="text-center pb-1" style={{ background: "rgb(255, 232, 232)", color: "red", marginBottom: -8, paddingTop: 0 }} class="d-inline-block label label-sm label-light-done label-inline text-uppercase">
                  <b style={{ fontSize: 11 }}>{isOffgrid(data?.id) ? T("status.checkin_alert_offgrid") : T("status.checkin_alert")}</b>
                  <FontAwesomeIcon style={{ marginLeft: 10, fontSize: 12 }} icon={agent.os === "iOS" ? faAngleRight : faArrowRight} />
                </Col>
              </Row>}
            {variant === "normal" && !error && showEditRow &&
              <Row className="mt-1">
                <Col className="text-center pb-1" style={{ background: "#ecf9ff", color: "#03a9f4", marginBottom: -8, paddingTop: 0 }} class="d-inline-block label label-sm label-light-done label-inline text-uppercase">
                  <b style={{ fontSize: 11 }}>{T("status.checkin_edit")}</b>
                  <FontAwesomeIcon style={{ marginLeft: 10, fontSize: 12 }} icon={agent.os === "iOS" ? faAngleRight : faArrowRight} />
                </Col>
              </Row>}
            {error && pathname === `/${data.code}/checkin/messages` &&
              <Button
                variant="outline-secondary"
                style={{
                  padding: '0.5rem 1rem',
                  fontSize: '0.9rem',
                  borderRadius: '0.5rem',
                  boxShadow: '0 0.25rem 0.5rem rgba(0, 0, 0, 0.15)',
                  backgroundColor: '#FFC107',
                  borderColor: '#ddd',
                  color: '#555',
                  justifyContent: 'center',
                  display: 'flex',
                  alignItems: 'center',
                  marginTop: '0.8rem'
                }}
                as={NavLink}
                to={`/${data.code}/checkin/edit`}
                state={{ from: pathname }}
              >
                {T("general.checkin_edit")}
              </Button>
            }
          </>}
        </Card.Body>
      </Card>
    </NavLink >
  );
}

const RoomInfo = ({ variant, checkIn, language, showPrice }) => {
  const roomCategory = checkIn.RoomCategory || checkIn.Room?.RoomCategory;

  let roomCategoryName = i18nValue(roomCategory, "name", language);
  if (!roomCategoryName) {
    roomCategoryName = checkIn.reservation?.unitGroup?.code + ". " + checkIn.reservation?.unitGroup?.name;
  }

  let roomCategoryDescription = i18nValue(roomCategory, "description", language);
  if (!roomCategoryDescription) {
    roomCategoryDescription = checkIn.reservation?.unitGroup?.description;
  }

  return <Row className={`text-left ${variant !== "small" ? "mb-2" : ""}`}>
    <Col xs={12}>
      <div className="d-flex" style={{ gap: 15, minWidth: 0, marginTop: 7 }}>
        <div
          style={{
            flex: "none",
            width: variant === "small" ? 50 : 75,
            height: variant === "small" ? 50 : 75,
            borderRadius: 5,
            borderColor: "#AAA",
            borderWidth: 1,
            borderStyle: "solid",
            textAlign: "center",
            background: "#EEE",
            verticalAlign: "middle",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          {roomCategory?.photo && (
            <img
              alt=""
              style={{
                width: variant === "small" ? 50 : 75,
                height: variant === "small" ? 50 : 75,
                borderRadius: 5,
              }}
              src={getCDNImage(roomCategory.photo)}
            />
          )}
          {!roomCategory?.photo && (
            <div>
              <Building width={40} height={40} color="#666666" />
            </div>
          )}
        </div>
        <div className="flex-fill" style={{ minWidth: 0 }}>
          <p
            className="mb-0"
            style={{
              lineHeight: 1.5,
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
            }}
          >
            {roomCategoryName}
          </p>
          {variant === "normal" && (
            <>
              <p
                className="mb-0 general-text-xs"
                style={{
                  lineHeight: 1.2,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {roomCategory?.m2 && roomCategory.m2 > 0 ? <b>{roomCategory.m2}m2.</b> : ""}{" "}
                {/* {roomCategoryDescription && roomCategoryDescription.slice(0, 60) + (roomCategoryDescription.length > 60 ? "..." : "")} */}
              </p>
              <p className="mb-0 general-text-xs text-truncate-3-lines" dangerouslySetInnerHTML={{ __html: roomCategoryDescription }}></p>
            </>
          )}

          {variant === "small" && (
            <div className="d-flex justify-content-between general-text-sm">
              <span>
                <FontAwesomeIcon
                  icon={faCalendarAlt}
                  className="mr-1 text-muted"
                />{" "}
                {formatDayMonth(checkIn.reservation?.arrival, T("general.short-dateformat"))}
                {/* {invertDate(
                  formatDate(checkIn.reservation?.arrival, false)
                )} */}
                {" "}
                -{" "}
                {formatDayMonth(checkIn.reservation?.departure, T("general.short-dateformat"))}
                {/* {invertDate(
                  formatDate(checkIn.reservation?.departure, false)
                )} */}
                {" "}
                <span className="font-italic text-muted">
                  ({checkIn.reservation?.adults} {T("checkin.adult-s")}
                  {checkIn.reservation?.childrenAges?.length > 0
                    ? " / " +
                    checkIn.reservation?.childrenAges.length +
                    T("checkin.child-s")
                    : ""}
                  )
                </span>
              </span>
              {showPrice && <span className="text-right font-weight-bold">
                {checkIn.reservation?.totalGrossAmount.amount}{" "}
                {checkIn.reservation?.totalGrossAmount.currency}
              </span>}
            </div>
          )}

        </div>
      </div>
    </Col>
  </Row>
}